import React from 'react';
import classNames from 'classnames';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import { Input } from '../../../../components/inputs/Input';
import { BaseInputProps } from './BaseInput';
import useT from '../../../../translation/src/hooks/useT';

export const StringInput: React.FC<BaseInputProps<string>> = ({ instance, onChange, disabled = false, className }) => {
  const { config, value } = instance;
  const mixedText = useT('mixed', { swc: true });
  const mixedStateTooltip = useT('Different values selected', { swc: true });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <div className={classNames('relative flex-1', className)}>
      <Input
        type="text"
        value={typeof value === 'string' ? value : ''}
        onChange={handleChange}
        placeholder={instance.isMixed ? mixedText : config.ui?.placeholder || ''}
        disabled={disabled || config.disabled}
        className={classNames('w-full', instance.isMixed && 'text-gray-400 dark:text-gray-500 bg-gray-50 dark:bg-gray-800 italic pr-8')}
      />
      {instance.isMixed && <QuestionMarkCircleIcon className="absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-neon-green-500 pointer-events-none z-20" title={mixedStateTooltip} />}
    </div>
  );
};
